export default __webpack_public_path__ + "static/media/info_5_mobile.95223807.png";